'use strict';

/* eslint-disable */
var _                   = require('lodash');
var $                   = require('jquery');
var Backbone            = require('backbone');
var PubSub              = require('tscom-pubsub');
var Router              = require('./routes/router');
var ModelOneId          = require('./models/oneid');
var ModelCms            = require('./models/cms');
var ModelGeo            = require('./models/geo');
var ModelConnect        = require('./models/connect');
var ModelOmniture       = require('./models/omniture');
var ModelCountdown      = require('./models/countdown');
var UserView            = require('./views/user');
var AbcHeaderView       = require('./views/abcheader');
var AbcFooterView       = require('./views/abcfooter');
var CssView             = require('./views/css');
var facebookSharer      = require('./util/facebook-share');
var VoteOptionCollection = require('./collections/vote-option');

var CONSTANTS           = require('./constants');
var TS_OMNITURE         = CONSTANTS.OMNITURE;
var TS_APP              = CONSTANTS.APP;
/* eslint-enable */

/**
 * @param options - {
 * widget_id: 'data/data.json' // REQUIRED string
 * container: $('#myWidget') // REQUIRED string || jQuery selector (http://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * modal: $('#wrapper') // string || jQuery selector (http://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * uniqueId: 'name-type-namespace-datetime' // string
 * cssUrl: 'http://a1.telesocpe.tv/styles/main.css' // string (absolute path)
 * hashState: false // boolean
 * endpoints: {cms: '//https://widgetstate.votenow.tv/v1/state/'} // object
 * }
 */

module.exports = function TelescopeWidget (options) {
    options = options || {};
    options.widget_id = options.widget_id || 'a170e073c250f331';
    options.hashState = options.hashState || false;
    options.endpoints = _.extend({
        cms: 'https://widgetstate.votenow.tv/v1/state'
    }, ($.type(options.endpoints) === 'object'? options.endpoints : {}));
    var controller = new Controller(options); // eslint-disable-line
};

function checkIfTrue( val ){
    return [ 'true', '1', true, 1, 'yes', 'yeah', 'okay', 'k' ].indexOf( val ) >= 0;
}

function Controller(options) {
    this.Models = {};
    this.Collections = {};
    this.Views = {};
    this.Routers = {};
    this.Controllers = {};
    this.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    this.app = options.container;
    this.defaultScopes = ['email','user_managed_groups','publish_actions'];
    this.scopes = _.clone(this.defaultScopes);

    this.options = options;
    this.connectUrl = options.connectUrl;
    this.proxyUrl = options.proxyUrl;
    this.firstPage = true;

    this.Models.Cms = new ModelCms({
        wid: options.widget_id,
        apiUrl: options.endpoints.cms,
        updateFrequency: parseInt(options.widget_poll_rate) ? parseInt(options.widget_poll_rate) : 30
    }, {controller: this});

    // var for client header search fix
    this.clientSearchOpen = false;

    //model,controllers,router set up
    this.Models.Cms.fetch()
        .then(this.setUpGeo.bind(this))
        .then(function() {
            let country = this.Models.Geo.get('geoheaders').country;
            const settings = this.Models.Cms.get('settings');
            
            const countryWid = (country === 'CA') ? settings.content_wid_ca : settings.content_wid_us;
            const copyWid = _.getQueryParamByName('copy_wid') || countryWid;
            const copySid = _.getQueryParamByName('copy_sid');

            this.Models.CopyCms = new ModelCms({
                wid: copyWid,
                sid: copySid,
                apiUrl: options.endpoints.cms,
                updateFrequency: parseInt(options.widget_poll_rate) ? parseInt(options.widget_poll_rate) : 30,
                multilanguage: true
            }, {
                controller: this,
                ignoreQSP:  true
            });
        
                    
            const lang = this.Models.CopyCms.get('language');

            document.documentElement.setAttribute('lang', lang);
            this.listenTo(this.Models.CopyCms, 'change:language', function() {
                const lang = this.Models.CopyCms.get('language');
                document.documentElement.setAttribute('lang', lang);
            });

            return this.Models.CopyCms.fetch();
        }.bind(this))
        .then(function() {
            var cms = this.Models.Cms;
            this.Models.Countdown = new ModelCountdown();

            this.listenTo(cms, 'change', this.setupCountdownModel.bind(this));
            this.setupCountdownModel();
        }.bind(this))
        .then(this.applyCustomStyling.bind(this,options))
        .then(function() {
            if(!this.Models.Geo.get('inRegion')) {
                console.warn('Out of Geo. Stopping CMS polling...');
                return this.Models.Cms.stopPolling();
            }
        }.bind(this))
        .then(this.setUpControllers.bind(this))
        .then(this.setUpConnectModel.bind(this))
        .then(this.setUpCollections.bind(this))
        .then(this.setUpOneId.bind(this,options))
        .then(this.setUpOmniture.bind(this))
        .then(this.setUpModelsAndRouter.bind(this,options))
        .then(this.setUpListeners.bind(this))
        .then(function() {
            var cms = this.Models.Cms;
            var windowOpen = cms.get('windowStatus');

            if(this.Models.OneId.get('id')) {

                this.Models.Omniture.set({
                    swid: this.Models.OneId.get('id'),
                    registeredFlag: 'true',
                    authenticatedFlag: 'true'
                });

                if(windowOpen) {
                    // Omniture event58 loginConfirmation: Trigger if one id user is logged in after loading site
                    PubSub.trigger('omniture:action', 'loginConfirmation');
                    return this.getVotes();
                }
            }
        }.bind(this))
        .then(this.afterSetUp.bind(this))
        .fail(function(error){
            console.warn('error on set up',error);
        });
}

/* PUBLIC FUNCTIONS */
_.extend(Controller.prototype, {
    /* ------------------------------------------------------------

                        Set Up Functions

    ------------------------------------------------------------ */
    setUpListeners: function() {
        window.addEventListener( 'resize', _.debounce( function(){
            PubSub.trigger( 'window-resize' );
        }, 300 ));

        //SID Change update
        this.listenTo(this.Models.Cms, 'change:sid',this.sidChange.bind(this));

        //Do get call when logged in to get votes
        this.listenTo(this.Models.User, 'change:id',function(){
            if(!this.Models.User.get('id')) {
                //reset collection
                this.setUpCollections();

                this.Routers.Router.navigate('home', {trigger: true});
            }
        }.bind(this));

        //fbshare listener
        this.listenTo(PubSub, 'facebookShare', function(data) {
            var lang = this.Models.CopyCms.get('language');
            var isLocal = /local/.test( window.location.hostname );

            var href = 'https://' + window.location.hostname + '/share.php?id=' + data.id + '&lang=' + lang;

            if( isLocal ){
                href = TS_APP.site + '/share.php?id=' + data.id + '&lang=' + lang;
            }

            facebookSharer( href );
        });

        this.listenTo(PubSub, 'launchLogin', function(callback) {
            this.Models.User.login()
                .then(function() {
                    const windowOpen = this.Models.Cms.get('windowStatus');
                    windowOpen && this.getVotes();
                }.bind(this))
                .then(function() {
                    if(this.Models.User.isConnected()) {
                        if(typeof callback === 'function') {
                            callback();
                        }
                    }
                }.bind(this));
        }.bind(this));

        /**
         * Omniture Event Tracking
         */
        this.listenTo(PubSub,'omniture:state',function(pageName){
            this.Models.Omniture.logPage(pageName);
        }.bind(this));
        this.listenTo(PubSub,'omniture:action',function(eventName,ctaText){
            this.Models.Omniture.logEventCustom(eventName,ctaText);
        }.bind(this));
        /**
         * OneID change in ID
         */
        this.listenTo(this.Models.OneId, 'change:id', function() {
            var swid = this.Models.OneId.get('id');
            this.Models.Omniture.set({
                swid: swid,
                authenticatedFlag: swid.length > 0 ? 'true' : 'false',
                registeredFlag: swid.length > 0 ? 'true' : 'false'
            });
        });

        /**
         * Facebook Share Experience
         */
        this.listenTo(PubSub, 'fbShareExperience', function(){
            var lang = this.Models.CopyCms.get('language');
            var url = new URL( TS_APP.site );
            url.searchParams.append('lang', lang);

            facebookSharer( url.toString() );

        }.bind(this));
        /**
         * Twitter Share Experience
         */
        this.listenTo(PubSub, 'twitterShareExperience', function(){
            var text = this.Models.CopyCms.get('text').share_experience[ 'main' ].twitter_text;
            var url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent( text );

            window.open( url, 'twitterShare', 'width=550,height=420' );
        }.bind( this ));

        // Listener to client header/footer
        // (DV-62) Header blank after closing
        // it looks like rendering is weird when the search menu closes
        // for some reason it hides the whole header, I found
        // hiding and showing the page rerenders it and it shows
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if(iOS) {
            $('.m-menu-search-link').on('click', function(){
                if(this.clientSearchOpen) {
                    this.clientSearchOpen = false;
                    document.activeElement.blur();
                    $('body .page-wrapper').hide();
                    window.setTimeout(function(){
                        $('body .page-wrapper').show();
                        document.activeElement.blur();
                    }, 100);
                } else {
                    this.clientSearchOpen = true;
                }
            }.bind(this));
            $('.m-menu-search-close').on('click', function(){
                if(this.clientSearchOpen) {
                    this.clientSearchOpen = false;
                    document.activeElement.blur();
                    $('body .page-wrapper').hide();
                    window.setTimeout(function(){
                        $('body .page-wrapper').show();
                    }, 100);
                }
            }.bind(this));
            $('.m-menu-global-link').on('click', function(){
                if(this.clientSearchOpen) {
                    this.clientSearchOpen = false;
                    document.activeElement.blur();
                    $('body .page-wrapper').hide();
                    window.setTimeout(function(){
                        $('body .page-wrapper').show();
                    }, 100);
                }
            }.bind(this));
        }
    },
    setUpConnectModel: function() {
        var recaptchaGateActive = checkIfTrue( this.Models.Cms.get('text').recaptcha.display );

        this.Models.Connect = new ModelConnect({
            apiKey: this.Models.Cms.get('settings').apiKey,
        }, {
            version_id: this.Models.Cms.get('settings').version_id,
            voteOption: this.Collections.VoteOption,
            authModel: this.Models.Auth,
            recaptchaGateActive: recaptchaGateActive,
            recaptchaUrl: this.proxyUrl + 'online/',
            apiUrl: this.connectUrl
        });

        this.Models.Connect.versionCheck = TS_APP.versionCheck;
    },
    setUpModelsAndRouter: function(options) {
        this.Models.User = this.Models.OneId;

        this.Routers.Router = new (Router({ hashState: false }))({
            el: options.container,
            modal: options.modal,
            uid: options.uniqueId,
            endpoints: options.endpoints,
            cms: this.Models.Cms,
            copyCms: this.Models.CopyCms,
            oneId: this.Models.OneId,
            controller: this
        });
    },
    setUpGeo: function() {

        // Akamai Geo Location
        this.Models.Geo = new ModelGeo({
            countries: this.Models.Cms.get('settings').countries
        });
        return this.Models.Geo.fetch();
    },
    setUpOmniture: function() {
        console.log('Omniture Set Up',TS_OMNITURE);
        this.Models.Omniture = new ModelOmniture({
            affiliateId: TS_OMNITURE.AFFILIATE_ID,
            videoNetwork: TS_OMNITURE.VIDEO_NETWORK,
            oneIdClientId: this.Models.Cms.get('settings').client_id,
            appName: TS_OMNITURE.APP_NAME,
            appVersion: TS_OMNITURE.APP_VERSION,
            pageNameCustom: TS_OMNITURE.PAGE_NAME,
            siteDifferentiator: TS_OMNITURE.SITE_DIFFERENTIATOR
        });
    },
    setUpOneId: function() {
        this.Models.OneId = new ModelOneId({},{
            cssOverride: this.Models.Cms.get('settings').css_override,
            responderPage: this.Models.Cms.get('settings').responder_page,
            clientId: this.Models.Cms.get('settings').client_id,
            context: this.Models.Cms.get('settings').oneid_context,
            source: this.Models.Cms.get('settings').oneid_source,
            controller: this,
            isMobileDevice: this.isMobileDevice,
            copyCms: this.Models.CopyCms
        });

        return this.Models.OneId.setUpOID();
    },
    setUpControllers: function() {
        //this.Controllers.Twitter = TwitterController();
    },
    setUpCollections: function() {
        var activeOptions = _.where(this.Models.Cms.get('data'), {active: '1'});
        this.Collections.VoteOption = new VoteOptionCollection(activeOptions, {
            maxVotes: this.Models.Cms.get('text').vote_settings.max_votes
        });
        this.Collections.VoteOption.forEach(function(model){
            model.set('maxVotes', this.Models.Cms.get('text').vote_settings.max_votes_per_contestant);
        }.bind(this));

    },
    afterSetUp: function () {
        if(!Backbone.History.started) {
            Backbone.history.start({pushState: true});
        }
        if(this._isOpen(Backbone.history.getFragment())) {
            this.Routers.Router.navigate('home', {trigger: true});
        }

    },

    /* ------------------------------------------------------------

                        App Relevant Functions

    ------------------------------------------------------------ */
    /**
     *
     */
    _isOpen: function (requestedFragment) {
        // 1. If not in region go to geo page and return false
        // 2. If window is closed go to error window page and return false
        // 3. If one id is down and user is on online go to error window page and return false
        // 4. Return true if it passes above conditions
        requestedFragment = requestedFragment || 'home';

        if(TS_APP.unrestrictedRoutes.indexOf(requestedFragment) > -1) {
            this.Routers.Router.navigate(requestedFragment, {trigger: true});
            return false;
        }

        if (!this.Models.Geo.get('inRegion')) {
            this.Routers.Router.navigate('error/geo', {trigger: true});
            return false;
        }
        // is the window closed?
        if(parseInt(this.Models.Cms.get('settings').window_status, 10)===0){
            this.Routers.Router.navigate('error/window', {trigger: true});
            return false;
        }

        // is one id down and is user on online
        if(this.Models.Cms.get('text').vote_settings.one_id_working === 'false' ){
            this.Routers.Router.navigate('error/window', {trigger: true});
            return false;
        }

        return true;
    },
    /**
     *
     */
    reachedMaxVotes: function() {
        return this.Collections.VoteOption.getTotalSubmitted() >= this.Collections.VoteOption.maxVotes;
    },
    /**
     * [ createAbcHeader ]
     */
    createAbcHeader: function(headerView){
        var model = this.Models.CopyCms.get('text').view_abc_header;

        if( !checkIfTrue( model.display ) ) return;

        this.Views.AbcHeaderView = new AbcHeaderView({
            model: this.Models.CopyCms
        });

        headerView.append(this.Views.AbcHeaderView.render().$el);
    },
    /**
     * [ createAbcFooter ]
     */
    createAbcFooter: function(footerView) {
        var display = this.Models.CopyCms.get('text').view_abc_footer.display;

        var ccpaSettings = {
            scriptURL: this.Models.Cms.get( 'settings' ).ccpa_script_url,
            className: this.Models.Cms.get( 'settings' ).ccpa_class_name
        };

        if( !checkIfTrue( display ) ) return;

        this.Views.AbcFooterView = new AbcFooterView({
            ccpaSettings: ccpaSettings,
            cms: this.Models.Cms,
            copyCms: this.Models.CopyCms
        });

        footerView.append(this.Views.AbcFooterView.render().$el);
    },
    /**
     * [ createHeader ]
     */
    createHeader: function (headerView) {
        this.Views.UserView = new UserView({
            model: this.Models.CopyCms,
            userModel: this.Models.User
        });
        headerView.append(this.Views.UserView.render().$el);
    },
    /**
     * [ createShareHeader ]
     */
    createShareHeader: function(shareView) {
        this.Views.StickyUserView = new UserView({
            model: this.Models.CopyCms,
            userModel: this.Models.User
        });

        shareView.append( this.Views.StickyUserView.render().$el );
    },
    /**
     *
     */
    sidChange: function () {
        var cms = this.Models.Cms;
        var windowOpen = cms.get('windowStatus');
        var windowPreviouslyOpen = cms.previous('windowStatus');
        var desiredRoute = Backbone.history.getFragment();

        if(windowOpen !== windowPreviouslyOpen) {
            this.setUpCollections();
            if(TS_APP.unrestrictedRoutes.indexOf(desiredRoute) > -1) return;
            this.afterSetUp();
        } else if( !checkIfTrue( windowOpen ) && !checkIfTrue( windowPreviouslyOpen ) ) {
            //DV-663: Going from closed page to closed page
            this.afterSetUp();
        }
    },

    setupCountdownModel: function() {
        var cms = this.Models.Cms;
        var text = cms.get('text');
        var meta = cms.get('metadata');
        var duration = parseInt(text.countdown.duration_in_seconds, 10);

        var startTime = meta.snapshot_start_timestamp || Math.round(Date.now() / 1000);
        var initTime = meta.current_timestamp;
        var startTimeChanged = startTime !== this.Models.Countdown.countdownStartTime;
        var durationChanged = duration !== this.Models.Countdown.countdownDuration;

        //If the duration is non-zero and the start time has changed
        if(duration > 0 && (startTimeChanged || durationChanged)) {
            this.Models.Countdown.start({
                countdownDuration: duration,
                countdownStartTime: startTime,
                serverTime: initTime
            });
        } else if(!duration) {
            this.Models.Countdown.stop();
            this.Models.Countdown.reset();
        }
    },


    /* ------------------------------------------------------------

                        Vote API Functions

    ------------------------------------------------------------ */

    submitVotes: _.throttle(function( data ) {

        PubSub.trigger('omniture:action','voteSubmitClick', 'Submit Vote');
        var votesArray = this.Collections.VoteOption.getAllWithCount();
        var options = {
            timestamp: new Date().getTime(),
            country: this.Models.Geo.get('geoheaders').country,
            state: this.Models.Geo.get('geoheaders').region,
            action_type: 'vote'
        };

        options.oneid = this.Models.User.get('id').replace('{', '').replace('}', '');

        // set vote count values
        var total = 0;
        var voteOptions = ['total'];

        // if the total votes are more than 0
        if(votesArray.length > 0 && this.Collections.VoteOption.getTotal() > 0){
            votesArray.forEach(function(element){
                var votesToSend = (parseInt(this.Collections.VoteOption.get(element).get('voteCount') ,10)) || 0;

                // if(votesToSend > 0) {
                options[element] = votesToSend;
                total += votesToSend;
                voteOptions.push(element);
                // }
            }.bind(this));

        // else if the total votes being submitted is 0
        } else {
            this.Collections.VoteOption.models.forEach(function(model){
                options[model.get('id')] = 0;
            });
        }

        options.total = total;

        this.Models.Connect.recaptchaToken = data.token;
        this.Models.Connect.set(options);
        this.Models.Connect.save()
            .done(function(response){

                //clear the set votes
                this.Models.Connect.unsetMultiple(voteOptions, { silent: true });

                switch(response.response_code) {
                // Success
                case '20':
                    //set up collections
                    if(!_.isUndefined(response.votestring) && response.votestring.length>0) {
                        this.Collections.VoteOption.updateVoteOptions(JSON.parse(response.votestring));
                        this.Routers.Router.currentView.render();
                    }

                    this.Routers.Router.thanks();
                    break;
                // Out of Geo
                case '22':
                    this.Routers.Router.error('geo');
                    break;
                // Window Closed
                case '40':
                    this.Routers.Router.error('window');
                    break;
                // General Error
                default:
                    this.Routers.Router.error('');
                    break;
                }

            }.bind(this))
            .fail(function(err){
                console.error('Vote Submission Failed',err);
                this.Routers.Router.error('');
            }.bind(this));

    },2000,{trailing: false}),

    getVotes: function() {
        var options = {
            timestamp: new Date().getTime(),
            country: this.Models.Geo.get('geoheaders').country,
            state: this.Models.Geo.get('geoheaders').region,
            action_type: 'get'
        };

        options.oneid = this.Models.User.get('id').replace('{', '').replace('}', '');

        this.Models.Connect.set(options);
        return this.Models.Connect.fetch()
            .done(function(response){
                this.Models.Connect.unsetMultiple(['response','status'], { silent: true });

                switch(response.response_code) {
                // Success
                case '20':
                    //set up collections
                    if(!_.isUndefined(response.votestring) && response.votestring.length>0) {
                        var parsed = JSON.parse(response.votestring);
                        if (parsed.total > 0) $('.submit').text(this.Models.CopyCms.get('text').views_vote_grid.change);
                        this.Collections.VoteOption.updateVoteOptions(parsed);
                    }
                    break;
                // Out of Geo
                case '22':
                    this.Routers.Router.error('geo');
                    break;
                // Window Closed
                case '40':
                    this.Routers.Router.error('window');
                    break;
                // General Error
                default:
                    this.Routers.Router.error('');
                    break;
                }
            }.bind(this))
            .fail(function(error){
                console.log('getVotes error:', error);
            });
    },

    /* ------------------------------------------------------------

                        Tracking Functions

    ------------------------------------------------------------ */

    _handlePageView: function (route){
        PubSub.trigger('omniture:state',route);
    },

    /**
     * [ applyCustomStyling ]
     */
    applyCustomStyling: function( options ){
        var namespace = 'namespace-' + ( new Date() ).getTime();
        var model = this.Models.CopyCms.get('text').customizations || {};
        var container = options.container[ 0 ];

        // add namespace
        container.classList.add( namespace );
        model.namespace = '#' + container.id + '.' + namespace;

        this.Views.Css = new CssView({
            model: model
        });

        this.Views.Css.render();
    },

}, Backbone.Events);



// WEBPACK FOOTER //
// ./app/scripts/App.js